import { Call } from "@ellaandil/ui";
import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { Link } from "@/components/ui/Link";
import type { PhoneLinkStoryblok } from "@/generated/sb/sb-types";

const telHref = (raw: string | undefined) => {
	const digits = (raw ?? "").replace(/[^\d+]/g, "");
	return digits ? `tel:${digits}` : undefined;
};

export const PhoneLinkBlok = ({
	blok,
	className,
}: BlokProps<PhoneLinkStoryblok> & {
	className?: string;
}) => {
	const href = telHref(blok.phone);
	if (!href) return null;

	return (
		<BlokWrap editable={blok} asChild>
			<Link as="a" href={href} className={className} leftIcon={Call}>
				{blok.phone}
			</Link>
		</BlokWrap>
	);
};
